import {
  green,
  primaryHover,
  white,
  secondaryHover,
  sand,
  lightGreen,
  buttonShadow,
} from '@/shared/styles/colors';
import { css } from '@emotion/native';
import { FONT_STYLES } from '@/shared/styles/constants';

export const baseButtonStyle = css({
  justifyContent: 'center',
  width: '100%',
  borderWidth: 1,
  borderRadius: 187,
});

export const baseLabelStyle = css({
  textTransform: 'uppercase',
  letterSpacing: 0.7,
  fontWeight: 'bold',
  fontSize: 14,
  ...FONT_STYLES.lora,
});

export const buttonVariants = {
  primary: {
    backgroundColor: green,
    labelColor: white,
    hoverColor: primaryHover,
    hoverLabelColor: white,
    hoverBorderColor: primaryHover,
    borderColor: green,
  },
  secondary: {
    backgroundColor: sand,
    labelColor: green,
    hoverColor: secondaryHover,
    hoverLabelColor: green,
    hoverBorderColor: secondaryHover,
    borderColor: lightGreen,
  },
  tertiary: {
    backgroundColor: 'transparent',
    labelColor: green,
    hoverColor: primaryHover,
    hoverLabelColor: white,
    hoverBorderColor: primaryHover,
    borderColor: green,
    borderWidth: 2,
  },
  tertiaryLight: {
    backgroundColor: 'transparent',
    labelColor: sand,
    hoverColor: sand,
    hoverLabelColor: lightGreen,
    hoverBorderColor: sand,
    borderColor: sand,
    borderWidth: 2,
  },
} as const;

export const buttonDimensions = {
  small: {
    maxWidth: {
      mobile: '100%',
      desktop: 528,
    },
    height: {
      mobile: 48,
      desktop: 48,
    },
  },
  medium: {
    maxWidth: {
      mobile: '100%',
      desktop: 528,
    },
    height: {
      mobile: 68,
      desktop: 68,
    },
  },
  large: {
    maxWidth: {
      mobile: '100%',
      desktop: 528,
    },
    height: {
      mobile: 72,
      desktop: 72,
    },
  },
} as const;

export const buttonTypography = {
  small: {
    fontSize: {
      mobile: 14,
      desktop: 14,
    },
  },
  medium: {
    fontSize: {
      mobile: 14,
      desktop: 14,
    },
  },
  large: {
    fontSize: {
      mobile: 14,
      desktop: 16,
    },
  },
} as const;

export const buttonEffects = {
  small: {
    shadow: null,
  },
  medium: {
    shadow: {
      shadowColor: buttonShadow,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 1,
      shadowRadius: 10.9,
    },
  },
  large: {
    shadow: {
      shadowColor: buttonShadow,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 1,
      shadowRadius: 10.9,
    },
  },
} as const;
